import { defineMessages } from 'react-intl';

export default defineMessages({
	errorMessage: {
		defaultMessage: "We couldn't save the value of this custom field.",
		description: 'Error message when the value of a forge custom field cannot be saved',
		id: 'cv.request.create.form.forge-field.error-message',
	},
	notFoundRequiredFieldTitle: {
		defaultMessage: 'Custom field not found',
		description:
			'Title of the error message shown in the flag when a custom field is required but is not found',
		id: 'cv.request.create.form.forge-field.not-found-required-title',
	},
	notFoundRequiredFieldDescription: {
		defaultMessage:
			"The {fieldName} custom field is required but couldn't be displayed. If this happens again, notify your admin.",
		description:
			'Description of the error message shown in the flag when a custom field is required but is not found',
		id: 'cv.request.create.form.forge-field.not-found-required-description',
	},
});
